export enum CustomFormFieldConditionType {
  EQUALS = 'EQUALS',
}
